module.exports = __webpack_public_path__ + "img/Pin-Location.1b96311c.svg";